// Utils
import { getGroupId, getGroupNotifications } from '../../groups/notificationGroupUtils';
import { getNotificationId } from '../../../../../../../common/notifications/notificationModelUtils';

export const getGroupPopupId = (group) => {
    const notifications = getGroupNotifications(group);

    if (notifications) {
        const notificationIds = notifications.map(getNotificationId);

        return `opt-out-${notificationIds.join('-')}`;
    }

    return `opt-out-${getGroupId(group)}`;
};
